export default {"src":"/_next/static/media/linkedin.94617dca.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};